<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>工单系统</el-breadcrumb-item>
            <el-breadcrumb-item>预设问题设置</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align:left">
        <el-col :span="24">
          <el-form :model="searchForm" :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-select filterable v-model="searchForm.OrderServiceID" clearable size="small">
                <el-option
                  v-for="(item,index) in winOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" icon="el-icon-search" @click="GetDefaultProblemList">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="initAddProblem">添加预设问题</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-table
            :data="problemList"
            style="width: 100%"
            row-key="ID"
            v-loading="loading"
            size="small"
          >
            <el-table-column prop="OrderServiceName" label="服务窗口名称"></el-table-column>
            <el-table-column prop="Problem" label="问题"></el-table-column>
            <el-table-column prop="SimpleDescribe" label="简述"></el-table-column>
            <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="initEditProblem(scope.row)" size="small">编辑</el-button>
                <el-popconfirm title="确定删除此条信息吗？" @onConfirm="DeleteProblem(scope.row)">
                  <el-button type="text" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-row style="margin-top:10px">
            <el-col :span="24">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                style="float:right"
              ></el-pagination>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-dialog :title="dialogTitle" :visible.sync="problemVisible">
        <el-form :model="problem" ref="serviceWinForm" :rules="problemRules">
          <el-form-item label="所属服务窗口" :label-width="formLabelWidth" prop="OrderServiceWinID">
            <el-select filterable v-model="problem.OrderServiceWinID" clearable size="small">
              <el-option
                v-for="(item,index) in winOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="问题" :label-width="formLabelWidth" prop="Problem">
            <el-input size="small" v-model="problem.Problem" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="简述" :label-width="formLabelWidth" prop="SimpleDescribe">
            <el-input
              size="small"
              type="textarea"
              :rows="3"
              v-model="problem.SimpleDescribe"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="解决方案" :label-width="formLabelWidth" prop="Answer">
            <el-input
              size="small"
              type="textarea"
              :rows="3"
              v-model="problem.Answer"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="解决方案图片" :label-width="formLabelWidth" prop="Picture">
            <el-upload
              action="http://eapi.ruizhiqi.cn/api/upload/uploadformdata"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              v-model="problem.Picture"
              size="small"
              :on-success="uploadSuccess"
              :on-remove="onRemove"
              multiple
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="OperProblem">保存</el-button>
          <el-button size="small" @click="problemVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="dialogImgPriviewVisible">
        <img width="100%" :src="dialogImageUrl" alt />
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import {
  GetOrderSerivceWin,
  GetOrderDefaultProblemPage,
  DeleteOrderDefaultProblem,
  UpdateOrderDefaultProblem,
  OrderDefaultProblemAdd
} from "../../until/ZeusApiSDK/Logic/OrderServiceLogic";
import {
  GetCurrentUserInfo,
  GetGuid,
  getNowDateStr
} from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { Predicate } from "../../until/ZeusApiSDK/Model/Predicate";
import { GetUserByName } from "../../until/ZeusApiSDK/Logic/StructureLogic";
import { TransDeleteUser } from '../../until/ZeusApiSDK/Logic/SysUserLogic';
export default {
  data() {
    return {
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      problemList: [],
      problemVisible: false,
      formLabelWidth: "150px",
      searchForm: { OrderServiceID: "" },
      problem: {},
      dialogTitle: "",
      problemRules: {
        //用户验证规则
        OrderServiceWinID: [
          { required: true, message: "请输入服务窗口名称", trigger: "blur" }
        ],
        Problem: [{ required: true, message: "请输入问题", trigger: "blur" }],
        Answer: [
          { required: true, message: "请输入解决方案", trigger: "blur" }
        ],
        SimpleDescribe: [
          { required: true, message: "请输入描述", trigger: "blur" }
        ]
      },
      winOptions: [],
      dialogImgPriviewVisible: false,
      dialogImageUrl: ""
    };
  },
  created() {
    this.currentUser = GetCurrentUserInfo();
    this.GetServiceWinOptions();
    this.GetDefaultProblemList();
  },
  methods: {
    uploadSuccess: function(res) {
      if (this.Pictures.indexOf(res.Data.Message) == -1) {
        this.Pictures.push(res.Data.Message);
      }
    },
    onRemove: function(file, filelist) {
      this.Pictures.splice(
        this.Pictures.indexOf(file.response.Data.Message),
        1
      );
    },
    handlePictureCardPreview: function(file) {
      this.dialogImageUrl = file.url;
      this.dialogImgPriviewVisible = true;
    },
    //更改每页显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetDefaultProblemList();
    },
    onCollapseChange: function() {},
    //翻页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetDefaultProblemList();
    },
    GetServiceWinOptions: function() {
      GetOrderSerivceWin().then(res => {
        if (res) {
          for (let r of res) {
            var option = { value: r.ID, label: r.ServiceName };
            this.winOptions.push(option);
          }
        }
      });
    },
    GetDefaultProblemList: function() {
      this.loading = TransDeleteUser;
      GetOrderDefaultProblemPage(
        this.searchForm.OrderServiceID,
        this.pageIndex,
        this.pageSize
      ).then(res => {
        this.totalCount = res.TotalCount;
        this.problemList = res.List;
        for (let p of this.problemList) {
          var s = this.winOptions.filter(x => x.value == p.OrderServiceWinID);

          if (s.length > 0) {
            p.OrderServiceName = s[0].label;
          }
        }
        this.loading = false;
      });
    },
    //刷新
    Refresh:function(){
      this.GetDefaultProblemList();
    },
    initAddProblem: function() {
      this.problem = {};
      this.problemVisible = true;
      this.dialogTitle = "添加预设问题";
    },
    initEditProblem: function(row) {
      this.problem = row;
      this.problemVisible = true;
      this.dialogTitle = "编辑预设问题";
    },
    OperProblem: function() {
      if (this.problem.ID) {
        UpdateOrderDefaultProblem(this.problem).then(res => {
          if (res == "success") {
            this.$message({
              message: "编辑成功",
              type: "success",
              center: true
            });
            this.problemVisible = false;
            this.GetDefaultProblemList();
          } else {
            this.$message({
              message: "编辑失败",
              type: "warning",
              center: true
            });
          }
        });
      } else {
        GetGuid().then(id => {
          this.problem.ID = id;
          this.problem.IsDelete = 0;
          this.problem.CreateTime = getNowDateStr();
          OrderDefaultProblemAdd(this.problem).then(res => {
            if (res == "success") {
              this.$message({
                message: "添加成功",
                type: "success",
                center: true
              });
              this.problemVisible = false;
              this.GetDefaultProblemList();
            } else {
              this.$message({
                message: "添加失败",
                type: "warning",
                center: true
              });
            }
          });
        });
      }
    },
    DeleteProblem: function(row) {
      var ids = row.ID;
      DeleteOrderDefaultProblem(ids).then(res => {
        if (res == "success") {
          this.$message({
            message: "删除成功",
            type: "success",
            center: true
          });
          this.GetDefaultProblemList();
          this.problemVisible=false;
        } else {
          this.$message({
            message: "删除失败",
            type: "warning",
            center: true
          });
        }
      });
    }
  }
};
</script>
